import { z } from 'zod';
import { ERROR_MESSAGES } from '~/constants';

export const privilegesSchema = z.object({
  id: z.number().optional(),
  privilegeType: z
    .string()
    .min(1, ERROR_MESSAGES.REQUIRED)
    .max(128, ERROR_MESSAGES.MAX_CHARACTER_LIMIT(128)),
  privilegeName: z
    .string()
    .min(1, ERROR_MESSAGES.REQUIRED)
    .max(1024, ERROR_MESSAGES.MAX_CHARACTER_LIMIT(1024)),
  privilegeNotes: z.string().max(512, ERROR_MESSAGES.MAX_CHARACTER_LIMIT(512)).nullable(),
  userAddedFlag: z.boolean().nullable().optional(),
  category: z
    .string()
    .min(1, ERROR_MESSAGES.REQUIRED)
    .max(64, ERROR_MESSAGES.MAX_CHARACTER_LIMIT(64)),
  // [MCV-1391] Custom-authored privileges have no medical_privileges catalog
  // row, so the backend returns specialtyId/privilegeId as null. zod's
  // .optional() accepts undefined but NOT null, so re-validating an unchanged
  // edit form for a user-added privilege threw, onSubmitError fired, and
  // errorHandler swallowed the issue — the user saw nothing happen on Save.
  privilegeId: z.number().nullable().optional(),
  specialtyId: z.number().nullable().optional(),
  specialtyName: z.object({
    value: z
      .string()
      .min(1, ERROR_MESSAGES.REQUIRED)
      .max(128, ERROR_MESSAGES.MAX_CHARACTER_LIMIT(128)),
    label: z.string().readonly(),
  }),
  assignmentDate: z.string().optional(),
});
